var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatsLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 20C3 19.4477 3.44772 19 4 19H20C20.5523 19 21 19.4477 21 20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20Z",
    fill: "#12131A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 3C14.3431 3 13 4.34315 13 6V16C13 16.5523 13.4477 17 14 17C14.5523 17 15 16.5523 15 16V6C15 5.44772 15.4477 5 16 5C16.5523 5 17 5.44772 17 6V16C17 16.5523 17.4477 17 18 17C18.5523 17 19 16.5523 19 16V6C19 4.34315 17.6569 3 16 3Z",
    fill: "#12131A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 9C6.34315 9 5 10.3431 5 12V16C5 16.5523 5.44772 17 6 17C6.55228 17 7 16.5523 7 16V12C7 11.4477 7.44772 11 8 11C8.55228 11 9 11.4477 9 12V16C9 16.5523 9.44772 17 10 17C10.5523 17 11 16.5523 11 16V12C11 10.3431 9.65685 9 8 9Z",
    fill: "#12131A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatsLine);
export default __webpack_public_path__ + "static/media/stats-line.eedb704274474610a4cf650242b81476.svg";
export { ForwardRef as ReactComponent };